module.exports = "<div [hidden]=\"!active\" class=\"tab-pane\">\n  <ul class=\"nav nav-tabs\">\n    <li class=\"nav-item\" *ngFor=\"let tab of subtabs\">\n      <a class=\"nav-link\" (click)=\"selectTab(tab)\" [class.active]=\"tab.active\">{{tab.title}}</a>\n    </li>\n  </ul>\n  <div class=\"tab-content\">\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/custom-tabs/custom-tab/custom-tabs.html
// module id = ./src/app/shared/components/custom-tabs/custom-tab/custom-tabs.html
// module chunks = main